import React, { useState } from "react";

import { SalesModeLayoutWrapper } from "./common/salesModeLayout.styles";
import TopNavigation from "./components/TopNavigation";
import MobileNav from "./components/MobileNav";

const SalesModeLayout = ({ children }) => {
    const [showMobileNav, setShowMobileNav] = useState(false);

    const handleToggleMobileNav = (bool) => {
        setShowMobileNav(bool);
    };
    return (
        <SalesModeLayoutWrapper>
            <TopNavigation handleToggleMobileNav={handleToggleMobileNav} />
            <section className="sales-layout__main-content">{children}</section>
            {showMobileNav && <MobileNav handleToggleMobileNav={handleToggleMobileNav} />}
        </SalesModeLayoutWrapper>
    );
};

export default SalesModeLayout;
